
const LogoIcon = () => (
  <svg viewBox="0 0 640 586" xmlns="http://www.w3.org/2000/svg" style={{width:'100%',height:'100%'}}>
    <defs>
      <linearGradient id="navlg2" x1="193" y1="476" x2="566" y2="103" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#43d3c5"/><stop offset="1" stopColor="#4088d8"/>
      </linearGradient>
      <linearGradient id="navlg3" x1="97" y1="598" x2="601" y2="95" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#7d8ce8"/><stop offset="1" stopColor="#6d7de0"/>
      </linearGradient>
      <linearGradient id="navlg1" x1="208" y1="470" x2="503" y2="175" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#56c8e9"/><stop offset="1" stopColor="#6a7dde"/>
      </linearGradient>
    </defs>
    <path fill="url(#navlg2)" opacity=".72" d="M291.75,66.48c-37.24,34.2-122.34,178.2-120.62,246.33s85.29,117.24,142.16,133.61,136.12,58.59,184.37,29.29c48.25-29.29,64.62-61.17,49.97-121.48-14.65-60.31-45.66-151.63-56-221.42s-57.72-93.05-84.43-99.08c-26.71-6.03-73.23-6.03-115.45,32.74Z"/>
    <path fill="url(#navlg3)" opacity=".6" d="M103.38,369.06c46.38-90.82,93.21-196.4,252.16-228.02,158.95-31.62,208.88,4.16,233.02,31.62,24.13,27.46,16.64,92.2,3.33,138.06s-10.82,72.49-37.45,107.44c-26.63,34.95-104.78,71.32-172.19,62.16-67.41-9.15-112.42,25.22-206.46,17.73-94.04-7.49-95.3-84.92-72.4-128.99Z"/>
    <path fill="url(#navlg1)" opacity=".72" d="M124.52,221.07c-11.54-77.26,38.12-157.14,191.54-127.38,153.42,29.75,252.91,256.63,274.29,291.03,21.39,34.4,9.3,102.28-25.1,132.96s-63.13,44.13-116.23,34.4c-53.09-9.73-53.81-35.34-122.81-75.51-69-40.16-180.3-112.32-201.69-255.51Z"/>
    <path fill="#fff" d="M387.62,192.25h-50.6l-74.06,210.16h46.2l15.4-46.7,13.2-42.38,24.19-73.51,23.47,73.51,13.2,42.38,14.66,46.7h47.67l-73.33-210.16Z"/>
    <path fill="#fff" d="M361.96,355.71l-2.79-9.63c-1.64-5.66-6.07-10.09-11.73-11.73l-9.63-2.79,9.67-2.85c5.6-1.65,9.98-6.03,11.63-11.63l2.85-9.67,2.8,9.64c1.64,5.65,6.06,10.07,11.71,11.71l9.64,2.8-9.65,2.82c-5.63,1.64-10.02,6.04-11.67,11.67l-2.82,9.65Z"/>
  </svg>
);

import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import styles from './Navigatie.module.css';


export default function Navigatie() {
  const { gebruiker, uitloggen, heeftPermissie } = useAuth();
  const navigate  = useNavigate();
  const [banner, setBanner]     = useState('');
  const [menuOpen, setMenuOpen] = useState(false);
  const [beheerOpen, setBeheerOpen] = useState(false);

  useEffect(() => {
    axios.get('/api/organisaties/platform-instellingen')
      .then(r => {
        const inst = r.data.instellingen;
        if (inst.banner_actief === '1' && inst.banner_tekst) setBanner(inst.banner_tekst);
      })
      .catch(() => {});
  }, []);

  async function handleUitloggen() {
    await uitloggen();
    navigate('/login');
  }

  const isSuperadmin = heeftPermissie('superadmin.alles');
  const isShadow = gebruiker?.is_shadow;

  async function handleShadowTerug() {
    const returnToken = localStorage.getItem('alyden_shadow_return_token');
    if (returnToken) {
      localStorage.setItem('alyden_token', returnToken);
      localStorage.removeItem('alyden_shadow_return_token');
      axios.defaults.headers.common['Authorization'] = `Bearer ${returnToken}`;
      window.location.href = '/superadmin';
    }
  }
  const isBeheerder  = heeftPermissie('beheer.gebruikers') || heeftPermissie('beheer.rollen');

  // Dynamische huisstijl per organisatie
  const primairKleur = gebruiker?.primaire_kleur;
  const navStijl = primairKleur && !isSuperadmin
    ? { background: `linear-gradient(135deg, ${primairKleur}DD, ${primairKleur})` }
    : {};
  const logoUrl = gebruiker?.logo_url;

  return (
    <>
      {isShadow && (
        <div className={styles.shadowBanner}>
          👁 Shadow access actief — {gebruiker?.organisatie_naam}
          <button onClick={handleShadowTerug} className={styles.shadowTerug}>
            ← Terug naar superadmin
          </button>
        </div>
      )}
      {!!banner && <div className={styles.banner}>📢 {banner}</div>}
      {!!gebruiker?.oefenmodus_actief && <div className={styles.oefenBanner}>📚 Oefenmodus actief</div>}

      <nav className={styles.nav} style={navStijl}>
        <div className={styles.navInner}>
          <NavLink to="/dashboard" className={styles.logo}>
            {logoUrl
              ? <img src={logoUrl} alt="Logo" className={styles.logoImg} />
              : <div className={styles.logoIcon}><LogoIcon /></div>
            }
            <span className={styles.logoTekst}>Alyden</span>
          </NavLink>

          <div className={styles.links}>
            <NavLink to="/dashboard"
              className={({ isActive }) => `${styles.link} ${isActive ? styles.actief : ''}`}>
              Dashboard
            </NavLink>
            <NavLink to="/beoordeling"
              className={({ isActive }) => `${styles.link} ${isActive ? styles.actief : ''}`}>
              Beoordeling
            </NavLink>
            <NavLink to="/outputs"
              className={({ isActive }) => `${styles.link} ${isActive ? styles.actief : ''}`}>
              Mijn outputs
            </NavLink>
            {(heeftPermissie('sessies.inzien_organisatie') || heeftPermissie('superadmin.alles')) && (
              <NavLink to="/org-outputs"
                className={({ isActive }) => `${styles.link} ${isActive ? styles.actief : ''}`}>
                Organisatie outputs
              </NavLink>
            )}
            {isBeheerder && (
              <div className={styles.dropdown}
                onMouseEnter={() => setBeheerOpen(true)}
                onMouseLeave={e => { if (!e.currentTarget.contains(e.relatedTarget)) setBeheerOpen(false); }}>
                <button className={`${styles.link} ${styles.dropdownTrigger}`}>Beheer ▾</button>
                {beheerOpen && (
                  <div className={styles.dropdownMenu}>
                    <NavLink to="/admin/gebruikers" className={styles.dropdownItem} onClick={() => setBeheerOpen(false)}>
                      👥 Gebruikers
                    </NavLink>
                    <NavLink to="/admin/rollen" className={styles.dropdownItem} onClick={() => setBeheerOpen(false)}>
                      🔑 Rollen & permissies
                    </NavLink>
                    {(isSuperadmin || gebruiker?.hierarchie !== 'plat') && (
                      <NavLink to="/admin/locaties" className={styles.dropdownItem} onClick={() => setBeheerOpen(false)}>
                        📍 Locaties & Afdelingen
                      </NavLink>
                    )}
                  </div>
                )}
              </div>
            )}
            {isSuperadmin && (
              <NavLink to="/superadmin"
                className={({ isActive }) => `${styles.link} ${styles.superadminLink} ${isActive ? styles.actief : ''}`}>
                Superadmin
              </NavLink>
            )}
          </div>

          <div className={styles.gebruikerWrap}>
            <button className={styles.gebruikerNaam} onClick={() => navigate('/profiel')}>
              {gebruiker?.naam || gebruiker?.email}
            </button>
            <button className={styles.uitlogKnop} onClick={handleUitloggen}>Uitloggen</button>
            <button className={styles.hamburger} onClick={() => setMenuOpen(!menuOpen)}>☰</button>
          </div>
        </div>

        {menuOpen && (
          <div className={styles.mobileMenu}>
            <NavLink to="/dashboard"        className={styles.mobileLink} onClick={() => setMenuOpen(false)}>Dashboard</NavLink>
            <NavLink to="/beoordeling"      className={styles.mobileLink} onClick={() => setMenuOpen(false)}>Beoordeling</NavLink>
            <NavLink to="/outputs"          className={styles.mobileLink} onClick={() => setMenuOpen(false)}>Mijn outputs</NavLink>
            {(heeftPermissie('sessies.inzien_organisatie') || heeftPermissie('superadmin.alles')) && (
              <NavLink to="/org-outputs" className={styles.mobileLink} onClick={() => setMenuOpen(false)}>Organisatie outputs</NavLink>
            )}
            {isBeheerder && <>
              <NavLink to="/admin/gebruikers" className={styles.mobileLink} onClick={() => setMenuOpen(false)}>Gebruikers</NavLink>
              <NavLink to="/admin/rollen"     className={styles.mobileLink} onClick={() => setMenuOpen(false)}>Rollen & permissies</NavLink>
              {(isSuperadmin || gebruiker?.hierarchie !== 'plat') && (
                <NavLink to="/admin/locaties" className={styles.mobileLink} onClick={() => setMenuOpen(false)}>Locaties & Afdelingen</NavLink>
              )}
            </>}
            {isSuperadmin && <NavLink to="/superadmin" className={styles.mobileLink} onClick={() => setMenuOpen(false)}>Superadmin</NavLink>}
            <button className={styles.mobileUitlog} onClick={handleUitloggen}>Uitloggen</button>
          </div>
        )}
      </nav>
    </>
  );
}
